import React from 'react';
import { queryKeyes } from '../../shared/queryKeys';
import { useQuery } from 'react-query';
import { loadEEOI, loadImodcsGraphData, loadVesselBasicInformation } from '../../VesselMaster/vesselMaster.hooks';
import Loading from '../../Components/Loading';
import ErrorComponent from '../../Components/ErrorComponent';
import { Card, CardBody, CardHeader, Col, Label, Row } from 'reactstrap';
import VesselDetailsHeader from 'Components/VesselDetailsHeader';

const ImoDcsPartial = (vesselId: any) => {
    // const [download, setDownload] = useState(false);

    // const handleDownloadButton = (e: any) => {
    //     setDownload(!download)
    // }

    /**
     * Calculate total of the given field
    * @returns number
    */
    const totalItem = (field: string) => {
        let total = 0;
        imodcsData.filter((item: any) => {
            return total += item[field]
        })
        return isNaN(total) ? 0 : total;
    }

    /** useQueries */
    /** Graph data */
    const { data: imodcsData, isLoading: imodcsloading, isError: imodcsError } = useQuery(
        [queryKeyes.vessel.IMODCSData.key, vesselId.vesselId],
        async () => {
            return await loadImodcsGraphData(parseInt(vesselId.vesselId))
        });

    /** Vessel's basic information */
    const { data: BasicInformation, isLoading: BasicInformationLoading, isError: BasicInformationError } = useQuery(
        [queryKeyes.vessel.VesselBasicInformation.key, vesselId.vesselId],
        async () => {
            return await loadVesselBasicInformation(parseInt(vesselId.vesselId))
        });

    /** EEOI */
    const { data: EEOI, isLoading: EEOILoading, isError: EEOIError } = useQuery(
        [queryKeyes.vessel.EEOI.key, vesselId.vesselId],
        async () => {
            return await loadEEOI(parseInt(vesselId.vesselId))
        });
    /** useQueries end */

    if (imodcsloading || BasicInformationLoading || EEOILoading) {
        return <Loading message='Loading required data!' />
    }
    if (imodcsError || BasicInformationError || EEOIError) {
        return <ErrorComponent message='Unbable to load required data' />
    }
    return (
        <>
            <Row className='mb-2'>
                <Col sm={2} className="d-flex align-items-end ps-0">
                    <p className='mb-0'>Last updated on :<br />
                        <strong className='text-muted'>{imodcsData[imodcsData.length - 1]?.start_date?.toString().substring(0, 10)}</strong>
                    </p>
                </Col>
                <Col sm={10}>
                    <VesselDetailsHeader />
                </Col>
                {/* <Col lg={1}>
                    <Label className='pos-end' onClick={handleDownloadButton}><i className='bx bx-download icon_s23' /></Label>
                </Col> */}
            </Row>
            <Row>
                {!(imodcsloading || BasicInformationLoading) && !(imodcsError || BasicInformationError) &&
                    <Card className='p-0'>
                        <CardHeader className='p-2 align-middle' >
                            <h5 className='m-0'>Basic information</h5>
                        </CardHeader>
                        <CardBody className='p-2 pb-0'>
                            <Row className='mb-2'>
                                <Col sm={4}>
                                    <div className='ele_row1 d-flex align-items-center'>
                                        <Label className='mb-0'>Gross Tonnage&nbsp;</Label>
                                        <strong className='mr-2'>&nbsp;:&nbsp;{BasicInformation?.gross_tonnage}</strong>
                                    </div>
                                </Col>
                                <Col sm={4}>
                                    <div className='ele_row1 d-flex align-items-center'>
                                        <Label className='mb-0'>Ice Class&nbsp;</Label>
                                        <strong className='mr-2'>&nbsp;:&nbsp;{BasicInformation?.ice_class}</strong>
                                    </div>
                                </Col>
                                <Col sm={4}>
                                    <Label className='mb-0'>Power Output&nbsp;-&nbsp;</Label>
                                </Col>
                            </Row>
                            <Row className='mb-2'>
                                <Col sm={4}>
                                    <div className='ele_row1 d-flex align-items-center'>
                                        <Label className='mb-0'>Net Tonnage&nbsp;</Label>
                                        <strong className='mr-2'>&nbsp;:&nbsp;{BasicInformation?.net_tonnage}</strong>
                                    </div>
                                </Col>
                                <Col sm={4}>
                                    <div className='ele_row1 d-flex align-items-center'>
                                        <Label className='mb-0'>EEDI&nbsp;</Label>
                                        <strong className='mr-2'>&nbsp;:&nbsp;{BasicInformation?.eedi}</strong>
                                    </div>
                                </Col>
                                <Col sm={4}>
                                    <div className='ele_row1 d-flex align-items-center'>
                                        <Label className='mb-0'>Main propulsion power&nbsp;</Label>
                                        <strong className='mr-2'>&nbsp;:&nbsp;{BasicInformation?.main_propulsion_power}</strong>
                                    </div>
                                </Col>
                            </Row>
                            <Row>
                                <Col sm={4}>
                                    <div className='ele_row1 d-flex align-items-center'>
                                        <Label className='mb-0'>Deadweight Tonnage&nbsp;</Label>
                                        <strong className='mr-2'>&nbsp;:&nbsp;{BasicInformation?.deadweight_tonnage}</strong>
                                    </div>
                                </Col>
                                <Col sm={4}>
                                    <div className='ele_row1 d-flex align-items-center'>
                                        <Label className='mb-0'>EEOI&nbsp;</Label>
                                        <Label className='mr-2'>&nbsp;:&nbsp;{EEOI?.average_eeoi}</Label>
                                    </div>
                                </Col>
                                <Col sm={4}>
                                    <div className='ele_row1 d-flex align-items-center'>
                                        <Label className='mb-0'>Auxillary engine(s)&nbsp;</Label>
                                        <strong className='mr-2'>&nbsp;:&nbsp;{BasicInformation?.auxillary_engine}</strong>
                                    </div>
                                </Col>
                            </Row>
                        </CardBody>
                    </Card>
                }
            </Row>
            <Row>
                <Card className='p-0'>
                    <CardHeader className='p-2 align-middle'>
                        <h5 className='m-0'>Total data</h5>
                    </CardHeader>
                    <CardBody className='nopadbottom p-0 m-0'>
                        <div className="table-responsive">
                            <table className="table m-0">
                                <thead className="table-light">
                                    <tr>
                                        <th className="text-center p-2">Sr. No.</th>
                                        <th className=' text-center p-2'>Start date (dd/mm/yyyy)</th>
                                        <th className=' text-center p-2'>End date (dd/mm/yyyy)</th>
                                        <th className=' text-center p-2'>Distance travelled (nm)</th>
                                        <th className=' text-center p-2'>Hours underway (hr)</th>
                                        <th className=' text-center p-2'>Diesel/Gas oil</th>
                                        <th className=' text-center p-2'>Fuel Oil</th>
                                        <th className=' text-center p-2'>Method used to measure fuel oil consumption</th>
                                        <th className=' text-center p-2'>Remarks (if any)</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr>
                                        <td className='text-center p-2'>1</td>
                                        <td className='text-center p-2'>{imodcsData[0]?.start_date.toString().substring(0, 10)} {imodcsData[0]?.start_date.toString().substring(12, 16)}</td>
                                        <td className='text-center p-2'>{imodcsData[imodcsData?.length - 2]?.end_date?.toString().substring(0, 10)} {imodcsData[imodcsData?.length - 2]?.end_date?.toString().substring(11, 16)}</td>
                                        <td className='text-center p-2'>{totalItem('distance_travelled')}</td>
                                        <td className='text-center p-2'>{totalItem('hours_underway')}</td>
                                        <td className='text-center p-2'>{totalItem('do_fuel_consumption').toFixed(2)}</td>
                                        <td className='text-center p-2'>{totalItem('fo_fuel_consumption').toFixed(2)}</td>
                                        <td className='text-center p-2'>Flow Meter</td>
                                        <td className='text-center p-2'></td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </CardBody>
                </Card>
            </Row>
            <Row>
                <Card className='p-0'>
                    <CardHeader className='p-2 align-middle'>
                        <h5 className='m-0'>Daily Reporting Data</h5>
                    </CardHeader>
                    <CardBody className='nopadbottom p-0 m-0'>
                        <div className="table-responsive vertical-table-scroll">
                            <table className="table m-0">
                                <thead className="table-light">
                                    <tr>
                                        <th className="text-center p-2">Sr. No.</th>
                                        <th className='text-center p-2'>Start date (dd/mm/yyyy)</th>
                                        <th className='text-center p-2'>End date (dd/mm/yyyy)</th>
                                        <th className='text-center p-2'>Distance travelled (nm)</th>
                                        <th className='text-center p-2'>Hours underway (hr)</th>
                                        <th className='text-center p-2'>Diesel/Gas oil</th>
                                        <th className='text-center p-2'>Fuel Oil</th>
                                        <th className='text-center p-2'>Method used to measure fuel oil consumption</th>
                                        <th className='text-center p-2'>Remarks (if any)</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {imodcsData?.map((item: any, index: number) => {
                                        return (
                                            <tr>
                                                <td className='text-center p-2'>{index + 1}</td>
                                                <td className='text-center p-2'>{item.start_date?.toString().substring(0, 10)} {item.start_date?.toString().substring(11, 16)}</td>
                                                <td className='text-center p-2'>{item.end_date?.toString().substring(0, 10)} {item.end_date?.toString().substring(11, 16)}</td>
                                                <td className='text-center p-2'>{item.distance_travelled}</td>
                                                <td className='text-center p-2'>{item.hours_underway}</td>
                                                <td className='text-center p-2'>{(item.do_fuel_consumption).toFixed(2)}</td>
                                                <td className='text-center p-2'>{(item.fo_fuel_consumption).toFixed(2)}</td>
                                                <td className='text-center p-2'>{/*item.method_used_to_measure_fueloil_consumption*/} Flow Meter</td>
                                                <td></td>
                                            </tr>
                                        )
                                    })}
                                </tbody>
                            </table>
                        </div>
                    </CardBody>
                </Card>
            </Row>
            <Row>
                <Card className='p-0'>
                    <CardHeader className='p-2 align-middle'>
                        <h5 className='m-0'>Footnotes:</h5>
                    </CardHeader>
                    <CardBody className='nopadbottom p-2'>
                        <ol>
                            <li>In accordance with the IMO ship identification number scheme, adopted by the Organization by resolution A.600(15).</li>
                            <li>As defined in regulation 2 of MARPOL Annex VI or other (to be stated).</li>
                            <li>GT should be calculated in accordance with the International Convention on Tonnage Measurement of Ships, 1969. If not applicable, note “N/A”.</li>
                            <li>NT should be calculated in accordance with the International Convention on Tonnage Measurement of Ships, 1969. If not applicable, note “N/A”.</li>
                            <li>DWT means the difference in tonnes between the displacement of a ship in water of relative density of 1.025 kg/m3 at the summer load draught and the lightweight of the ship. The summer load draught should be taken as the maximum summer draught as certified in the stability booklet approved by the Administration or an organization recognized by it. If not applicable, note "N/A".</li>
                            <li>EEDI should be calculated in accordance with the IMO Resolution MEPC.245(66) on the 2014 Guidelines on the Method of Calculation of the Attained Energy Efficiency Design Index (EEDI) for New Ships, as amended.</li>
                            <li>Ice class should be consistent with the definition set out in the International Code for ships operating in polar waters (Polar Code), (resolutions MEPC.264(68) and MSC.385(94)). If not applicable, note "N/A".</li>
                            <li>Power output (rated power) of main and auxiliary reciprocating internal combustion engines over 130 kW (to be stated in kW). Rated power means the maximum continuous rated power as specified on the nameplate of the engine.</li>
                            <li>Method used to measure fuel oil consumption: 1: Method using BDNs, 2: Method using flow meters, 3: Method using bunker fuel tank monitoring.</li>
                        </ol>
                    </CardBody>
                </Card>
            </Row>
        </>
    )
}

export default ImoDcsPartial